module.exports = __webpack_public_path__ + "static/french_circle_2-41dc29893228f1db78461dd1ca25b5b9.svg";